import { useState } from 'react'
import { HugeiconsIcon } from '@hugeicons/react'
import { Cancel01Icon, Search02Icon } from '@hugeicons-pro/core-bulk-rounded/index'
import { IconButton, TextField, useTheme } from '@mui/material'
import InputAdornment from '@mui/material/InputAdornment'
import PropTypes from 'prop-types'
import { useDebouncedCallback } from 'use-debounce'

const SearchInput = ({
    disabled = false,
    label,
    onChange,
    placeholder = null,
    size = 'small',
    sx = [],
    value,
    variant = 'outlined',
}) => {
    const theme = useTheme()

    const [searchTerm, setSearchTerm] = useState(value)

    const handleInputChange = useDebouncedCallback((value) => {
        onChange(value)
    }, 500)

    const handleSearchTermChange = (event) => {
        handleInputChange.cancel()
        setSearchTerm(event.target.value)
        handleInputChange(event.target.value)
    }

    const handleClearSearchTerm = () => {
        setSearchTerm('')
        onChange('')
    }

    return (
        <TextField
            disabled={disabled}
            label={label}
            placeholder={placeholder}
            size={size}
            slotProps={{
                input: {
                    startAdornment: (
                        <InputAdornment position="start">
                            <HugeiconsIcon
                                color={theme.palette.primary.main}
                                icon={Search02Icon}
                                size={20}
                            />
                        </InputAdornment>
                    ),
                    endAdornment: searchTerm ? (
                        <InputAdornment
                            position="end"
                            onClick={handleClearSearchTerm}
                        >
                            <IconButton
                                color="primary"
                                size="small"
                                title="Clear search"
                            >
                                <HugeiconsIcon
                                    icon={Cancel01Icon}
                                    size={20}
                                />
                            </IconButton>
                        </InputAdornment>
                    ) : null,
                },
            }}
            sx={[{ backgroundColor: theme.palette.background.paper }, ...(Array.isArray(sx) ? sx : [sx])]}
            value={searchTerm}
            variant={variant}
            onChange={handleSearchTermChange}
        />
    )
}

SearchInput.propTypes = {
    disabled: PropTypes.bool,
    label: PropTypes.string,
    placeholder: PropTypes.string,
    size: PropTypes.oneOf(['small', 'medium']),
    sx: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])),
        PropTypes.func,
        PropTypes.object,
    ]),
    value: PropTypes.string,
    variant: PropTypes.oneOf(['standard', 'outlined', 'filled']),
    onChange: PropTypes.func,
}

export default SearchInput
